module.exports = __webpack_public_path__ + "img/2024-07-01a_3.9553cab2.jpg";